import { Debug, urlParser } from '@hh.ru/browser-api-utils';

const HTTP_REGEXP = /^https?:\/\//;
const PROTOCOL_REGEXP = /^[a-z]+:/;

class UrlHelper {
    domainWhitelist: string[] = [];

    linkSpecialPrefixes: string[] = ['mailto', 'tel', 'skype'];

    setDomainWhitelist = (whitelist: string[]) => {
        this.domainWhitelist = whitelist;
    };

    getSecondLevelDomain = (url: string): string => url.split('.').slice(-2)?.[0] || '';

    isAbsolute = (url: string): boolean => {
        return HTTP_REGEXP.test(url);
    };

    isSpecial = (url: string): boolean => this.linkSpecialPrefixes.some((prefix) => !!url && url.startsWith(prefix));

    isInternal = (url: string, origin: string | null): boolean => {
        const isAbsoluteLink = this.isAbsolute(url);
        const isAnotherProtocolLink = !isAbsoluteLink && PROTOCOL_REGEXP.test(url);
        const isRelativeLink = !isAbsoluteLink && !isAnotherProtocolLink;
        const isTheSameOriginLink = !!origin && !!url && url.startsWith(origin);
        return isRelativeLink || isTheSameOriginLink;
    };

    isExternalLink = (url: string, origin: string | null): boolean => {
        if (this.isInternal(url, origin)) {
            return false;
        }

        let parsedUrl: ReturnType<typeof urlParser> | undefined;

        try {
            parsedUrl = urlParser(url);
        } catch {
            Debug.log('out error', new Error(`redux-spa-middleware: Parse URL error`), { url });
        }

        const isHostInWhitelist =
            !!parsedUrl?.host && this.domainWhitelist.some((domain) => parsedUrl?.host.endsWith(domain));

        if (!origin) {
            return !isHostInWhitelist;
        }

        let parseOrigin: ReturnType<typeof urlParser> | undefined;

        try {
            parseOrigin = urlParser(origin);
        } catch {
            Debug.log('out error', new Error(`redux-spa-middleware: Parse OriginURL error`), { origin });
        }

        if (!parsedUrl || !parseOrigin) {
            return !isHostInWhitelist;
        }

        const urlSecondLevelDomain = this.getSecondLevelDomain(parsedUrl.host);
        const originSecondLevelDomain = this.getSecondLevelDomain(parseOrigin.host);

        return urlSecondLevelDomain !== originSecondLevelDomain && !isHostInWhitelist;
    };
}

export default new UrlHelper();
